import { type QueryHookOptions, useQuery } from "@apollo/client";
import { StreamClipsQuery } from "../graphql/queries";
import type {
  StreamClipsQueryType,
  StreamClipsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useStreamClipsQuery = (
  options?: QueryHookOptions<
    StreamClipsQueryType,
    StreamClipsQueryVariablesType
  >
) => {
  return useQuery<StreamClipsQueryType, StreamClipsQueryVariablesType>(
    StreamClipsQuery,
    options
  );
};
